export const Constants: IConstants = {
    activeProjects: <any>[],
    lateUsers: <any>[],
    adminLevelUsers: <any>[],
    projectList: <any>[],
    allCounts: null,   
} 